import React, { useState } from "react";
import {Container, Row, Col} from "react-bootstrap";
import Navbar from "../../navbar/spanish";
import Footer from "../../footer/spanish";
import "../../../styles/blog_style.css"
import b1 from "../../../assets/images/rb1.png";
import dp from "../../../assets/images/p.png";
import b2 from "../../../assets/images/rb2.webp";
import shareIcon from "../../../assets/icons/share.png"; // Import the share icon image
import RSSUsage from "../../share_social/english";


const Blog15Es = () => {

    const [isShareOpen, setIsShareOpen] = useState(false);

    const handleShareIconClick = () => {
      setIsShareOpen(true);
    };
  
    const handleCloseShare = () => {
      setIsShareOpen(false);
    };

    return (
        <div style={{backgroundColor:'rgb(33, 67, 136)'}}>
        <Navbar langToggleHref="/blog/3-reasons-why-you-should-be-saving"/>
        <Container className="resp_blog">
            <Row>
                <Col>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <p style={{fontSize:'13px'}}><img src={dp} width="40px"/> &nbsp;Panthelys Theodorakopoulos &nbsp;&bull;&nbsp; 
May 12, 2023
 &nbsp;&bull;&nbsp; 1 Min. de lectura</p>
                </div>
              <div style={{ cursor: 'pointer' }} onClick={handleShareIconClick}>
                <img src={shareIcon} alt="Share" style={{ width: '20px' }} />
              </div>
            </div>
                
                    <h1>3 Razones Por Las Que Deberías Estar Ahorrando</h1>
                    <br/>
                    <p>
                    ¡Hola!
                    <br/>
                    <br/>
                    Hay muchas razones por las que debemos ahorrar, pero aquí están 3 razones importantes. Los ahorros te dan...
                    <br/>
                    <ul>
<li>Tranquilidad de espíritu</li>
<li>La capacidad de comprar artículos y experiencias que desee (por ejemplo, una casita) sin endeudarse</li>
<li>Ayuda a mantener tus finanzas organizadas</li>

</ul>
Sin embargo, cuando ahorre, ¡asegúrese de mantener su dinero seguro en un banco! En el 2019, el 12,2 % de los hogares latinos en los EE. UU. no estaban bancarizados, en comparación con el 2,5 % de los hogares blancos (FDIC). Adicionalmente, en México, sólo ⅓ de las mujeres adultas tienen una cuenta bancaria (Visa).
<br/>
                    <br/>
                    Es importante que nuestras comunidades almacenen nuestro dinero en un banco porque las cuentas bancarias ofrecen...
<br/>
<ul>
<li>Seguridad </li>
<li>Conveniencia</li>
<li>Puede darle intereses sobre su dinero</li>
<li>Ayudarle a acceder al crédito más fácilmente</li>
</ul>
¡Hoy es el día de empezar ahorrar más y mantener su dinero seguro!
<br/>
                    <br/>
                    <b>banco </b>
                    <b>ahorra </b>
                    <b>finanzas </b>
                    <b>dinero </b>
                    <b>debito</b>
                    <b>deuda</b>
                    <b>comunidad</b>
                    <b>Credito</b>
</p>
                </Col>
            </Row>
        </Container>
        {isShareOpen && <RSSUsage onClose={handleCloseShare} buttonLink="" />}
        <Container className="seeAllBlog">
            <Row style={{color:'#ffffff'}}>
                <Col>    <p>Entradas Recientes</p></Col>
                <Col>  <a href="/es/blog" style={{textAlign:'Right', color:'#ffffff'}}><p> Ver todo </p></a></Col>
            </Row>
        <Row>
    <Col style={{textAlign:'center'}}>
    <img src={b1}/>
    </Col>
    <Col>
    <img src={b2}/>
    </Col>
</Row>
<Row>
    <Col>
    <h1>Nuestro Features, Part 3: Enrico Lopez-Yañez, Principal Pops Director at the Nashville...</h1>
    </Col>
    <Col>
    <h1>Nuestro Features, Part 2: Elizabeth Narváez-Vega, College Success Coach at Conexión...

</h1>
    </Col>
</Row>
        </Container>
        <Footer/>
        </div>
    )
}

export default Blog15Es;